export default __webpack_public_path__ + "static/media/right-arrow.c5387b22.svg";